module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921052334_T.90189736.jpg";